import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import './Form.css';

function ContactForm() {
    const [state, handleSubmit] = useForm("xrbzdjyw");
    
    if (state.succeeded) {
        return <p>Thanks for joining!</p>;
    }
    
    return (
        <div className="new_home_web">
            <div className="responsive-container-block big-container">
                <img className="imgBG" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw65.png" alt="Background" />
                <div className="responsive-container-block textContainer">
                    <div className="topHead">
                        <p className="text-blk heading">
                            Book your <span className="orangeText">FREE TRIAL!</span>
                        </p>
                        <div className="orangeLine"></div>
                    </div>
                    <p className="text-blk subHeading">
                        We will get back to you as soon as possible. <br/> If you need an urgent response, feel free to contact us on WhatsApp: <a href="https://wa.me/message/XCAPPOTEII6ML1" target="_blank" rel="noopener noreferrer">+65 9135 1633</a>
                    </p>
                </div>
                <div className="responsive-container-block container">
                    <div className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-7 wk-ipadp-10 line">
                        <form className="form-box" onSubmit={handleSubmit}>
                            <div className="container-block form-wrapper">
                                <div className="responsive-container-block">
                                    <div className="left4">
                                        <div className="responsive-cell-block wk-ipadp-6 wk-tab-12 wk-mobile-12 wk-desk-6">
                                            <input
                                                className="input"
                                                name="firstName"
                                                placeholder="First Name"
                                                required
                                            />
                                        </div>
                                        <div className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                                            <input
                                                className="input"
                                                name="lastName"
                                                placeholder="Last Name"
                                                required
                                            />
                                        </div>
                                        <div className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                                            <input
                                                className="input"
                                                name="email"
                                                type="email"
                                                placeholder="Email Address"
                                                required
                                            />
                                            <ValidationError
                                                prefix="Email"
                                                field="email"
                                                errors={state.errors}
                                            />
                                        </div>
                                        <div className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12 lastPhone">
                                            <input
                                                className="input"
                                                name="phoneNumber"
                                                placeholder="Phone Number"
                                            />
                                        </div>
                                    </div>
                                    <div className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-12 wk-ipadp-12">
                                        <textarea
                                            className="textinput"
                                            name="message"
                                            placeholder="Message"
                                            required
                                        ></textarea>
                                        <ValidationError
                                            prefix="Message"
                                            field="message"
                                            errors={state.errors}
                                        />
                                    </div>
                                </div>
                                <button type="submit" className="send" disabled={state.submitting}>
                                    Send
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;
